export default {
  name: 'Logo',
  data() {
    return {
      icons: {
        cs: {
          '2024': require('@icon/logo/cs/2024.svg?raw'),
          '2025': require('@icon/logo/cs/2025.svg?raw'),
          '2026': require('@icon/logo/cs/2026.svg?raw'),
          '2027': require('@icon/logo/cs/2027.svg?raw'),
          '2028': require('@icon/logo/cs/2028.svg?raw'),
          '2029': require('@icon/logo/cs/2029.svg?raw'),
          '2030': require('@icon/logo/cs/2030.svg?raw'),
          '2031': require('@icon/logo/cs/2031.svg?raw'),
          '2032': require('@icon/logo/cs/2032.svg?raw'),
          '2033': require('@icon/logo/cs/2033.svg?raw'),
          '2034': require('@icon/logo/cs/2034.svg?raw'),
        },
        de: {
          '2024': require('@icon/logo/de/2024.svg?raw'),
          '2025': require('@icon/logo/de/2025.svg?raw'),
          '2026': require('@icon/logo/de/2026.svg?raw'),
          '2027': require('@icon/logo/de/2027.svg?raw'),
          '2028': require('@icon/logo/de/2028.svg?raw'),
          '2029': require('@icon/logo/de/2029.svg?raw'),
          '2030': require('@icon/logo/de/2030.svg?raw'),
          '2031': require('@icon/logo/de/2031.svg?raw'),
          '2032': require('@icon/logo/de/2032.svg?raw'),
          '2033': require('@icon/logo/de/2033.svg?raw'),
          '2034': require('@icon/logo/de/2034.svg?raw'),
        },
        sk: {
          '2024': require('@icon/logo/sk/2024.svg?raw'),
          '2025': require('@icon/logo/sk/2025.svg?raw'),
          '2026': require('@icon/logo/sk/2026.svg?raw'),
          '2027': require('@icon/logo/sk/2027.svg?raw'),
          '2028': require('@icon/logo/sk/2028.svg?raw'),
          '2029': require('@icon/logo/sk/2029.svg?raw'),
          '2030': require('@icon/logo/sk/2030.svg?raw'),
          '2031': require('@icon/logo/sk/2031.svg?raw'),
          '2032': require('@icon/logo/sk/2032.svg?raw'),
          '2033': require('@icon/logo/sk/2033.svg?raw'),
          '2034': require('@icon/logo/sk/2034.svg?raw'),
        },
      },
    }
  },
  computed: {
    icon() {
      const year = new Date().getFullYear()
      return this.icons[this.lang][year] || this.icons[this.lang]['2034']
    },
    lang() {
      return this.$store.app.context.app.i18n.locale
    },
  },
}
